import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import { Modal, } from 'antd';
import { DatePicker, Space, Button } from 'antd';
import React, { useState } from 'react';
import { makeStyles } from "@mui/material/styles";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import axios from 'axios';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { Backdrop, MenuItem, Select } from '@mui/material';

// import axios from 'axios';

const dateFormat = 'YYYY/MM/DD';
const { Column, ColumnGroup } = Table;


const Accounts: React.FC = (props: any) => {

  const useStyles = makeStyles((theme) => ({
      backdrop: {
        background: "black",
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
  }));


  const [isModalVisible, setIsModalVisible] = useState(false);
  const [forgotPasswordInfo, setForgotPasswordInfo] = useState({
    username:"",
    Email:""
  });
  const [isModalCreateVisible, setIsModalCreateVisible] = useState(false);
  const [isModalAcceptedVisible, setIsAcceptedModalVisible] = useState(false);
  const [currentAdminAccount, setCurrentAdminAccount] = useState({});
  const [enteredstatus, setEnteredStatus] = useState('');
  const [newAccount,setNewAcount] = useState(
    {
      Name:"",
      Email:"",
      Password:"",
      ContactNo:""
    }
  );

  const showModal = (e:any,account:any) => {
    setIsModalVisible(true);
    setForgotPasswordInfo({
      username:account.Email,
      Email:account.Email
    });
  };

  const showAcceptModal = () => {
    setIsAcceptedModalVisible(true);
  };

  const showModalCreate = () => {
    setIsModalCreateVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    ForgotPassword();
  };

  const handleAcceptOk = () => {
    setIsAcceptedModalVisible(false);
    UpdateAccount();
  };

  const handleCreateOk = () => {
    setIsModalCreateVisible(false);
    console.log(newAccount);
    AddAccount();
    setNewAcount({ Name:"",
    Email:"",
    Password:"",
    ContactNo:""})
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsAcceptedModalVisible(false);
  };

  const handleCreateCancel = () => {
    setIsModalCreateVisible(false);
    setNewAcount({ Name:"",
    Email:"",
    Password:"",
    ContactNo:""})
  };


  const statusChangeHandler = (event:any,adminAccount:any) => {
    setEnteredStatus(event.target.value);
    setCurrentAdminAccount(adminAccount);
    showAcceptModal();

};

  const columns = [

    { field: 'id', headerName: 'ID', width: 170 },
    { field: 'Name', headerName: 'NAME', width: 170 },
    { field: 'Email', headerName: 'EMAIL', width: 170 },
    { field: 'ContactNo', headerName: 'CONTACT', width: 170 },
    { field: 'UserType', headerName: 'TYPE', width: 170 },
    { field: 'VerifiedStatus', headerName: 'VERIFICATION', width: 170 },
    {
      field: 'password', headerName: 'PASSWORD', width: 190,
      renderCell: (params:any) => {
      return(
      <strong>
        <Button type="primary" onClick={(e)=>showModal(e,params.row)}>
                          Change Password
                        </Button>
             </strong>)},
    },
    {
      field: 'ProfileStatus', headerName: 'ACCOUNT STATUS', width: 190,
      renderCell: (params: GridCellParams) => (<strong>
      
          
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            style = {{width:"180px"}}
            onChange={(e) => statusChangeHandler(e, params.row)}
            value={params.value}
    
          >
            <MenuItem value={"Accepted"}>Accepted</MenuItem>
            <MenuItem value={"Rejected"}>Rejected</MenuItem>
          </Select>
        </strong>),
    }

  ];

  const [data1, SetData] = useState([]);

  const [open, setOpen] = useState(true);

  const handleBackDropClose = () => {
    setOpen(false);
  };
  const classes = useStyles();
  useIonViewDidEnter(() => {

    axios.get('https://dev.northroom.co.za/api/bizprop/admin/all')
      .then(function (response) {
        // handle success
        //console.log(response.data);
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  });

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setNewAcount(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  async function UpdateAccount() {
    /* @ts-ignore */
    let tempAccount = currentAdminAccount;
    /* @ts-ignore */
    
    tempAccount.ProfileStatus = enteredstatus;

    //console.log(tempAccount);

    
    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/users/admin/update",
        data: tempAccount,
      })
        .then(function (response) {
          //handle success
          //console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }
    
  }

  async function AddAccount() {

    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/users/admincreate",
        data: newAccount,
      })
        .then(function (response) {
          //handle success
          console.log(response);
          axios.get('https://dev.northroom.co.za/api/bizprop/admin/all')
            .then(function (response) {
              // handle success
              console.log(response.data);
              SetData(response.data);
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
            .then(function () {
              // always executed
            });
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }

  }

  async function ForgotPassword() {

    console.log(forgotPasswordInfo)
    
    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/users/forgotpassword",
        data: forgotPasswordInfo,
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }
    
    
  }

  


  const { name } = useParams<{ name: string; }>();

  return (
    <IonPage>
        <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      ></Backdrop>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow class="ion-text-center">
            <PageHeader
              className="site-page-header"
              onBack={() => { props.history.goBack() }}
              title="Admin Account"
            />
          </IonRow>
        </IonToolbar>
        <Modal
                      
                      visible={isModalAcceptedVisible}
                      onOk={handleAcceptOk}
                      onCancel={handleCancel}
                    >
                      <Space direction="vertical">
                        {/* @ts-ignore */}
                        <p>{enteredstatus+" "} {currentAdminAccount.Name}</p>
                      </Space>
                    </Modal>
      </IonHeader>

      <IonContent fullscreen >

        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader>

                  </IonCardHeader>

                  <IonCardContent>
                    <IonRow>

                      <IonCol>
                       
                      <Button type="primary" onClick={showModalCreate}>
                          Create Account
                        </Button>
                     
                        <Modal title="Create Account" visible={isModalCreateVisible} onOk={handleCreateOk} onCancel={handleCreateCancel}>
                          <Space direction="vertical">
                            <Input name="Name"  type ="string" placeholder="Name"  value={newAccount.Name} onChange={handleChange}/>
                            <Input name="Email" type ="text" placeholder="Email"  onChange={handleChange}/>
                            <Input name="Password" type ="text" placeholder="Password"  onChange={handleChange}/>
                            <Input name="ContactNo" type ="number" placeholder="Contact Number"  onChange={handleChange} />
                          </Space>
                          <hr></hr>
                       
                        </Modal>

                        <Modal title="Change Password" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                          <Space direction="vertical">
                            <Input placeholder="Account Email" value={forgotPasswordInfo.Email} />
                          </Space>
                          <hr></hr>
                          <p>Check your email for password change instructions</p>

                        </Modal>
                      </IonCol>

                    </IonRow>
                    <IonRow>
                      <IonCol>
                      <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>
                          <DataGrid
                            rows={data1}
                            columns={columns}
                            components={{
                              Toolbar: GridToolbar,
                            }}
                            filterModel={{
                              items: [
                                { columnField: 'Name', operatorValue: 'contains', value: '' },
                              ],
                            }}
                          />
                        </div>
                      </IonCol>
                    </IonRow>

                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>


  );
};

export default Accounts;